import { evalContext, signal, untrackDepth } from '../signal'

import type { Reactive } from '../types'

export function originBind(target: any, key: string): void
export function originBind(target: Reactive, key: string): void {
  if (
    (evalContext !== undefined || untrackDepth === 0) &&
    target.__rr_signals?.[key]?.value === undefined
  ) {
    target.__rr_signals ??= {}
    target.__rr_signals[key] ??= signal(NaN, key)
    void target.__rr_signals[key].value
  }
}
